import StyleSheet from 'react-native-media-query';

import constants from '../../Config/constants';
import themeColor from '../../Theme/colors';
import themeStyle, { globalSpacing } from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';

export const { ids, styles } = StyleSheet.create({
  boxWrapperWeb: {
    display: 'none',
    [`@media ${breakpoints.lg}`]: {
      marginBottom: globalSpacing,
      display: 'block',
    },
  },
  boxWrapperMobile: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    [`@media ${breakpoints.lg}`]: {
      display: 'none',
    },
  },
  // @ts-ignore: sticky work on web, not needed the element using this style on mobile
  boxContainer: constants.isWeb
    ? {
        ...themeStyle.flex1,
        position: 'sticky',
        top: 0,
        [`@media ${breakpoints.lg}`]: {
          marginTop: -53, // offset the actual spacing to top
          paddingTop: 53, // add padding to top equal to offset for sticky spacing to top
        },
      }
    : themeStyle.flex1,
  box: {
    ...themeStyle.flex1,
    ...themeStyle.pageHorizontalSpacingSmall,
    ...themeStyle.pageVerticalSpacingSmall,
    ...themeStyle.pageBackground,
    ...themeStyle.shadowOverAll,
    [`@media ${breakpoints.xs}`]: {
      ...themeStyle.pageHorizontalSpacing,
    },
    [`@media ${breakpoints.sm}`]: {
      paddingHorizontal: 40,
    },
    [`@media ${breakpoints.lg}`]: {
      ...themeStyle.pageHorizontalSpacing,
      ...themeStyle.pageVerticalSpacing,
      borderRadius: 20,
    },
  },
  contentWrapper: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRow,
    ...(constants.isWeb && themeStyle.spacingBottom),
    [`@media ${breakpoints.md}`]: themeStyle.spacingTopLarge,
  },
  leftContentWrapper: {
    ...themeStyle.flex1,
    [`@media ${breakpoints.lg}`]: {
      marginLeft: globalSpacing * 1.5,
      marginRight: globalSpacing * 4.2,
    },
  },
  contentContainer: {
    ...themeStyle.flex1,
    ...themeStyle.spacingTopMedium,
    ...(!constants.isWeb && themeStyle.pageHorizontalSpacing),
  },
  detailsBox: {
    ...themeStyle.pageVerticalSpacing,
    ...themeStyle.pageHorizontalSpacing,
    ...themeStyle.spacingBottom,
    borderWidth: 1,
    borderColor: themeColor.gray,
    borderRadius: 4,
    [`@media ${breakpoints.xs}`]: {
      ...themeStyle.pageVerticalSpacingSmall,
      ...themeStyle.pageHorizontalSpacingSmall,
    },
  },
  placeOrderButtonMobile: {
    ...themeStyle.spacingTopMedium,
    [`@media ${breakpoints.lg}`]: {
      display: 'none',
    },
  },
  leftComponentChildContainer: {
    [`@media (min-width: ${constants.PAGE_MAX_WIDTH}px)`]:
      themeStyle.spacingRightXLarge,
  },
  sectionDivider: {
    marginHorizontal: -globalSpacing,
    [`@media ${breakpoints.sm}`]: {
      marginHorizontal: 0,
    },
  },
});
